// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__h1VUR","iconWithCounter":"styles_iconWithCounter__4r1L5","counterForLabel":"styles_counterForLabel__M_YB9","counterForIcon":"styles_counterForIcon__oDuqb"};